<template>
    <CustomLink
        class="CustomLinkBanner"
        :to="to"
        :href="href"
        cursor-text="Go"
        cursor-type="go"
    >
        <div class="CustomLinkBanner__content">
            <span class="CustomLinkBanner__line" v-if="line_1">
                {{ line_1 }}
                <span class="CustomLinkBanner__icon">
                    <FontIcon icon="arrow" color="black" size="stretch" />
                </span>
            </span>
            <span class="CustomLinkBanner__line" v-if="line_2">
                {{ line_2 }}
                <span class="CustomLinkBanner__icon" v-if="!line_1">
                    <FontIcon icon="arrow" color="black" size="stretch" />
                </span>
            </span>
        </div>
    </CustomLink>
</template>

<script setup>
defineProps({
    to: {
        type: [String, Object],
        required: false,
    },
    href: {
        type: String,
        required: false,
        default: '',
    },
    line_1: {
        type: String,
        required: true,
    },
    line_2: {
        type: String,
        required: false,
        default: '',
    },
})
</script>

<style lang="scss">
.theme--white {
    .CustomLinkBanner {
        &:hover {
            border: 1px solid var(--black);
            color: var(--black);

            .CustomLinkBanner__icon {
                .font-icon svg {
                    fill: var(--black);
                }
            }
        }
    }
}

.CustomLinkBanner {
    @include heading-2;

    --dark-color: hsl(
        from var(--page-theme-base-colour, var(--lime-green)) h s l / 0.5
    );

    display: block;
    width: 100%;
    background-color: var(--page-theme-base-colour, var(--lime-green));
    color: var(--black);
    text-decoration: none;
    text-align: center;
    border: 1px solid transparent;
    box-shadow: 0px 0.5rem 0px 0px var(--dark-color);
    transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
    grid-column: 2 / span 22;

    &:hover {
        background: transparent;
        border: 1px solid var(--page-theme-base-colour, var(--lime-green));
        color: var(--page-theme-base-colour, var(--lime-green));
        box-shadow: none;
        transform: scale(0.99);

        .CustomLinkBanner__icon {
            transform: rotate(180deg);

            .font-icon svg {
                fill: var(--page-theme-base-colour, var(--lime-green));
            }
        }
    }
}

.CustomLinkBanner__icon {
    display: inline-block;
    margin-left: 1rem;
    transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
    width: 2rem;

    @include small-only {
        width: 1.1rem;
    }
}

.CustomLinkBanner__content {
    padding: 2.5rem 1.5rem;
}

.CustomLinkBanner__line {
    display: block;
}
</style>
